import httpClient, { buildQueryString } from "./httpClient";

const defaultRequest = (...args) => httpClient.request(...args);
const DEFAULT_CANCELLATION_TIMING = "period_end";

const resolveCancellationArgs = (optionsOrRequest, maybeRequest) => {
  if (typeof optionsOrRequest === "function") {
    return {
      options: {},
      request: optionsOrRequest,
    };
  }

  return {
    options: optionsOrRequest || {},
    request: maybeRequest || defaultRequest,
  };
};

const buildCancellationBody = (options = {}) =>
  JSON.stringify({
    cancellationTiming:
      options.cancellationTiming || DEFAULT_CANCELLATION_TIMING,
  });

export const normalizeSubscriptionLunaKeysResponse = (
  response,
  params = {}
) => ({
  items: Array.isArray(response.data)
    ? response.data
    : response.data?.items || [],
  pagination: response.pagination ||
    response.data?.pagination || {
      page: Number(params.page) || 1,
      limit: Number(params.limit) || 25,
      total: Array.isArray(response.data) ? response.data.length : 0,
      pages: Array.isArray(response.data) && response.data.length > 0 ? 1 : 0,
    },
});

export const getSubscriptionLunaKeys = async (
  params = {},
  request = defaultRequest
) => {
  const response = await request(
    `/v1/dashboard/subscription/lunakeys${buildQueryString(params)}`
  );

  return normalizeSubscriptionLunaKeysResponse(response, params);
};

export const cancelSubscriptionLunaKey = (
  redeemCodeId,
  optionsOrRequest,
  maybeRequest
) => {
  const { options, request } = resolveCancellationArgs(
    optionsOrRequest,
    maybeRequest
  );

  return request(
    `/v1/dashboard/subscription/lunakeys/${encodeURIComponent(redeemCodeId)}/cancel`,
    {
      method: "POST",
      body: buildCancellationBody(options),
    }
  );
};

export const getCustomerSubscriptionLunaKeys = async (
  customerId,
  params = {},
  request = defaultRequest
) => {
  const response = await request(
    `/v1/dashboard/subscription/customers/${encodeURIComponent(customerId)}/lunakeys${buildQueryString(params)}`
  );

  return normalizeSubscriptionLunaKeysResponse(response, params);
};

export const cancelCustomerSubscriptionLunaKey = (
  customerId,
  redeemCodeId,
  optionsOrRequest,
  maybeRequest
) => {
  const { options, request } = resolveCancellationArgs(
    optionsOrRequest,
    maybeRequest
  );

  return request(
    `/v1/dashboard/subscription/customers/${encodeURIComponent(customerId)}/lunakeys/${encodeURIComponent(redeemCodeId)}/cancel`,
    {
      method: "POST",
      body: buildCancellationBody(options),
    }
  );
};

export const createBillingPortalSession = (
  customerId,
  request = defaultRequest
) =>
  request("/v1/dashboard/stripe/create-portal-session", {
    method: "POST",
    body: JSON.stringify({ customerId }),
  });
